import { faBan, faSearchPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Component, Fragment } from "react";
import { Button, Modal } from "react-bootstrap";
import LoadingSpinnerSm from "../../spinners/LoadingSpinnerSm";
import $ from "jquery";
import NotAllowed from "../../other/NotAllowed";

class TestQItem extends Component {
    state = {
        questionData: null,
        noPermission: false,
        showZoomImgModal: false,
        fileExists: null,
    };

    /* blobToBuffer = (object) => {
        const blob = object;
        const buffer = Buffer.from(blob);
        const bufferBase64 = buffer.toString("base64");
        return bufferBase64;
    }; */

    getqItemQuestionData = async (questionID) => {
        const { fetchURL, onShowAlert, finishedLoadingID, onFinishedLoading } = this.props;
        const passData = {
            qItemID: questionID,
        };
        try {
            const response = await fetch(`${fetchURL}${this.props.view === "doEvaluation" || this.props.view === "editEvaluation" ? "/eval-question-item-details" : "/question-item-details"}`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });

            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission" || fetchedData.status === "noParamAvailable") {
                        this.setState({ noPermission: true, loading: false });
                    } else if (fetchedData.status === false) {
                        onShowAlert({ variant: "danger", message: fetchedData.message });
                    } else {
                        const qItemData = fetchedData.qItemData[0];
                        const questionData = {};
                        questionData.qitem_type_code = qItemData.qitem_type_code;
                        if (qItemData.qitem_type_code === "WORD") {
                            questionData.qitem_string = qItemData.qitem_string;
                        } else {
                            //pliki są obrazkami lub filmami
                            let questionName = qItemData.qitem_file_name;
                            questionName = questionName.replace(/\s+/g, "_");
                            questionData.qitem_file_name = questionName;
                            questionData.qitem_file_type = qItemData.qitem_file_type;

                            this.checkIfFileExists(questionName);
                        }
                        this.setState({ questionData: questionData }, () => onFinishedLoading(finishedLoadingID));
                    }
                });
            } else {
                onShowAlert({ variant: "danger", message: response.status });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." });
            this.setState({ loading: false });
            setTimeout(this.getqItemQuestionData(questionID), 4000);
        }
    };

    checkIfFileExists = async (fileName) => {
        const { fetchURL } = this.props;
        const passData = {
            fileName: fileName,
        };
        try {
            const response = await fetch(`${fetchURL}/check-if-file-exists`, {
                credentials: "include", //include - bez tego nie będą pojawiać się ciasteczka w przeglądarce
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(passData),
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    this.setState({ fileExists: fetchedData.fileExists }, () => {
                        if (this.state.fileExists === false)
                            this.props.onShowAlert({ variant: "warning", message: "Jeden lub więcej plików w tym pytaniu są niepoprawnie załadowane lub nie istnieją.", fading: 2500 });
                    });
                });
            } else {
                this.setState({ alert: { variant: "danger", message: response.status }, loading: false });
            }
        } catch (err) {
            this.setState({ loading: false, alert: { variant: "danger", message: "Błąd połączenia z serwerem. Spróbuję pobrać/wysłać dane jeszcze raz." } });
            setTimeout(this.checkIfFileExists(fileName), 4000);
        }
    };

    resizeWordsFont = () => {
        let fontSize = 0;

        if ($("#question .test-qitem-word .test-word").text().length <= 5) fontSize = 7;
        else if ($("#question .test-qitem-word .test-word").text().length <= 7) fontSize = 6.5;
        else if ($("#question .test-qitem-word .test-word").text().length <= 10) fontSize = 6;
        else if ($("#question .test-qitem-word .test-word").text().length <= 12) fontSize = 5.5;
        else fontSize = 5;

        $("#question .test-qitem-word .test-word").css("font-size", `${fontSize}rem`);

        let longestWord = 0;
        $(".answer .test-qitem-word .test-word").each(function () {
            if ($(this).text().length > longestWord) longestWord = $(this).text().length;
        });

        if (longestWord <= 5) fontSize = 5.5;
        else if (longestWord <= 7) fontSize = 5;
        else if (longestWord <= 10) fontSize = 4.5;
        else if (longestWord <= 12) fontSize = 4;
        else fontSize = 3.5;

        $(".answer .test-qitem-word .test-word").css("font-size", `${fontSize}rem`);

        $(".test-word").addClass("center");
    };

    componentDidUpdate() {
        this.resizeWordsFont();
        if (this.state.questionData) {
            $(`img`).fadeTo(50, 1);
            $(`video`).fadeTo(1000, 1);
            $(".test-qitem-word")
                .delay(200)
                .queue(function () {
                    $(this).addClass("visible").dequeue();
                });
        }

        if (this.state.showZoomImgModal && this.state.questionData.qitem_type_code === "VIDEO") {
            $(".zoom-image-modal-loading").css("max-height", 1078);

            $(".loading-spinner").css({ width: $(".zoom-image-modal-loading").width(), height: $(".zoom-image-modal-loading").height() });
            $(".sk-chase").css({ left: ($(".zoom-image-modal-loading").width() - 40) / 2, top: ($(".zoom-image-modal-loading").height() - 40) / 2 });

            setTimeout(() => {
                $(".zoom-image-modal-loading").addClass("faded");
                $(".zoom-image-modal-loading").delay(200).addClass("d-none");
            }, 200);
        }
    }

    componentDidMount() {
        this.getqItemQuestionData(this.props.questionID);
        this.resizeWordsFont();
    }

    render() {
        const { questionData, noPermission, showZoomImgModal, fileExists } = this.state;
        const { showAnswer } = this.props;
        return (
            <Fragment>
                {noPermission ? (
                    <NotAllowed />
                ) : (
                    <Fragment>
                        {!questionData ? (
                            <div className="test-qitem-loading h-100">
                                <LoadingSpinnerSm />
                            </div>
                        ) : (
                            <Fragment>
                                {questionData.qitem_type_code === "WORD" ? (
                                    <div className={showAnswer ? `test-qitem-word ${showAnswer}` : "test-qitem-word"}>
                                        <p className="test-word">{questionData.qitem_string}</p>
                                    </div>
                                ) : (
                                    <Fragment>
                                        {fileExists === true ? (
                                            <Fragment>
                                                {questionData.qitem_type_code === "IMAGE" ? (
                                                    <div className={showAnswer ? `test-qitem-image text-center ${showAnswer}` : "test-qitem-image text-center"}>
                                                        <img src={`questions/${questionData.qitem_file_name}`} alt={`${questionData.qitem_file_name}`} />
                                                    </div>
                                                ) : (
                                                    <video controls src={`questions/${questionData.qitem_file_name}`} className={showAnswer ? `${showAnswer}` : ""}></video>
                                                )}
                                                {questionData.qitem_type_code === "VIDEO" && (
                                                    <Button variant="outline-dark" className="zoom-question-btn" onClick={() => this.setState({ showZoomImgModal: true })}>
                                                        <FontAwesomeIcon icon={faSearchPlus} />
                                                    </Button>
                                                )}
                                            </Fragment>
                                        ) : (
                                            fileExists === false && (
                                                <div className="test-qitem-no-file">
                                                    <div className="no-file">
                                                        <FontAwesomeIcon icon={faBan} />
                                                    </div>
                                                </div>
                                            )
                                        )}
                                    </Fragment>
                                )}
                            </Fragment>
                        )}
                    </Fragment>
                )}

                {showZoomImgModal && (
                    <Modal show={showZoomImgModal} onHide={() => this.setState({ showZoomImgModal: false })} className="zoom-image-modal">
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                            {questionData.qitem_type_code === "IMAGE" ? (
                                <div className={showAnswer ? `test-qitem-image text-center ${showAnswer}` : "test-qitem-image text-center"}>
                                    <img src={`questions/${questionData.qitem_file_name}`} alt={`${questionData.qitem_file_name}`} />
                                </div>
                            ) : (
                                questionData.qitem_type_code === "VIDEO" && (
                                    <Fragment>
                                        <div className="zoom-image-modal-loading">
                                            <div className="loading-spinner">
                                                <div className="sk-chase">
                                                    <div className="sk-chase-dot"></div>
                                                    <div className="sk-chase-dot"></div>
                                                    <div className="sk-chase-dot"></div>
                                                    <div className="sk-chase-dot"></div>
                                                    <div className="sk-chase-dot"></div>
                                                    <div className="sk-chase-dot"></div>
                                                </div>
                                            </div>
                                        </div>
                                        <video controls src={`questions/${questionData.qitem_file_name}`} className="zoom-modal-video"></video>
                                    </Fragment>
                                )
                            )}
                        </Modal.Body>
                    </Modal>
                )}
            </Fragment>
        );
    }
}

export default TestQItem;
